import React, {useContext, useState, useEffect} from 'react'
import t from 'helpers/I18n'
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";

import {AppDataContext} from 'contexts/app-data'
import { legal_info_steps_config, personal_info_steps_config, pro_info_steps_config } from "steps/steps-config";
import { BASE_URL } from '../../env';
import getCookie from '../../functions/getcookie';
import deleteCookie from '../../functions/deleteCookie';

import StepsWrapper from "steps/steps-wrapper";

import PrivateUsage from './legal-info/02-private-usage';
import OccupationActivity from './legal-info/03-occupation-activity';
import Income from './legal-info/04-income';
import IncomeSource from './legal-info/05-income-source';
import IncomeSourceOther from './legal-info/05-income-source-other';
import FiscalResidence from './legal-info/06-fiscal-residence';
import HasUsAddress from './legal-info/07-has-us-address';
import UsCitizen from './legal-info/08-us-citizen';
import Political from './legal-info/09-political';
import Insider from './legal-info/10-insider';
import JoinReason from './legal-info/11-join-reason';
import JoinReasonOther from './legal-info/11-join-reason-other';

import IDStep from './id-step/id-step';

const LegalSteps = () => {

    const {state, dispatch} = useContext(AppDataContext)
    const [error, setError ] = useState([])
    const history = useHistory();

    const getKeyByValue = (object, value) => ( Object.keys(object).find(key => object[key].step_position === value))
    const getDataFromContext = (step_ID) => (state.raw_leagal_data[step_ID])

    const { id, locale } = useParams()
    const lang = localStorage.getItem('language')


    const base_URL = `${BASE_URL}/onboarding-entrepreneur-front/v1/`
    const fetch_init_options = {
        method: 'POST',
        credentials: "include",
        mode: "cors",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',            
        }
    }

    const errorsHandeling = function (response) {
         setError(JSON.parse(response.message))
    }

    const _step_service = function ({ step_ID, setIsLoading, next_step }) {
        const fetch_url = base_URL+"step"
        const stepFieldData = getDataFromContext(step_ID)
        let data = []

        for (let field in stepFieldData) {
            !field.startsWith("__") && 
            data.push({
                "fieldId": field,
                "fieldValue": stepFieldData[field] 
            })
        }

        setIsLoading(true)
        const fetch_init = {
            ...fetch_init_options,
            body: JSON.stringify(
            [...data]
            )
        }

        fetch(fetch_url, fetch_init).catch( error => {
            console.log("error : "+ error)
        }).then(response => {
            if (response.status === 200) return {status: 200}
            if (response.status === 400) return response.json()
        }).then(response => {
            if (response.status === 400) {
                if (getCookie('sf-payload-ident')) {
                    deleteCookie()
                    // history.push('/')
                    window.location.href = window.location.origin
                } else if (getCookie('sf-payload-ident') === undefined) (
                    window.location.href = window.location.origin
                    // history.push('/')
                )
                errorsHandeling(response)
                setIsLoading(false)
            }
            if (response.status === 200) {
                setTimeout(function(){
                    setIsLoading(false)
                    history.push(next_step)
                }, 100)
            }
        })
    }

    const _media_service = function ({ id, setIsLoading, value }) {
        const fetch_url = base_URL+"media/"+id
 
        // setIsLoading(true)

        const fetch_init = {
            ...fetch_init_options,
            body: JSON.stringify(
            {...value}
            )
        }

        fetch(fetch_url, fetch_init).catch( error => {
            console.log("error : "+ error)
        }).then(response => {
            if (response.status === 200) return {status: 200}
            if (response.status === 400) return response.json()
        }).then(response => {
            if (response.status === 400 ) {
                       if (getCookie('sf-payload-ident')) {
                    deleteCookie()
                    // history.push('/')
                        //    window.location.href = window.location.origin
                           window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`)
                } else if (getCookie('sf-payload-ident') === undefined) (
                        //    window.location.href = window.location.origin
                           window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`)
                    // history.push('/')
                )
                errorsHandeling(response)
                // setIsLoading(false)
            }
            if (response.status === 200) {
                setTimeout(function(){
                    // setIsLoading(false)
                }, 100)
            }
        })
    }

    const setDataToContext = (step_ID, step_URL, name, value) => {
            dispatch({
                type: 'SET_RAW_LEGAL_DATA',
                step: {step_ID, step_URL, step_position},
                value: {[name] : value}
            })
        }
    


    const steps = legal_info_steps_config.steps
    const step_info = steps[id]
    if (step_info === undefined) {
        window.location.href = (`${window.location.origin}/${lang.toLowerCase()}/404`);
    }
    const {step_position, step_ID, step_URL, step_form} = step_info
    const title = t('sectionTitle.openAccount')
    // const total_steps = Object.keys(steps).length + Object.keys(legal_info_steps_config.steps)

    // const total_steps = Object.keys(steps).length + Object.keys(personal_info_steps_config.steps).length
    const total_steps = Object.keys(steps).length + Object.keys(personal_info_steps_config.steps).length + Object.keys(pro_info_steps_config.steps).length
    
    const loaded = id === "end-flow" ? 0.1 :(step_position / total_steps) * 100
    const stepGroupTitle = id === 'end-flow' ? t("exit_messages.header_title") : t('general.legal_questions')
    const step_URL_baseName = `/${locale}/legal-steps/`

    const step_init = {
        step_ID,
        step_position,
        step_form,
        error,
        step_URL : step_URL_baseName + step_URL,
        next_step : step_position >= 1 && step_position < total_steps ? `${step_URL_baseName}${steps[getKeyByValue(steps, step_position + 1)].step_URL}` : "/",
        _step_service,
        _media_service,
        getDataFromContext,
        setDataToContext
    }

    useEffect(() => {
        // fetch(`${BASE_URL}/onboarding-entrepreneur-front/v1/payload/media?side=front&ident=QxB6jbficZ3ZxpfF1g5BPC56UxuAZabh389ztCmXo1ZKDo9PAShzaB5jxc8e96Poevesc1pG7GhU_VSuScG5h8U7ZVFJDL6W5JUnHm2Y4TBkrK9zDCk_89J5XxlLQn7LBlKgjJgB35oj-dSV81clneUCw0-xMUHJZ9rwY8wm7tPPNZtIptA1-EXFV4qubyy6c8iunF8kFwS4FgUvVqiMcd_glHJmbhEnzbfd4h7daM2vuTdk6TAul_66NSzrbyoUFalOqgUSikqeSnTGJCvY_JlGz0bFw_ApJsxalLRmqSpbi4VuXbCQ1_B7uK_nPzdCk6uvBvyBu80BMZY0A9s6cw`, {
        //     credentials: "include",
        // mode: "cors",
        // headers: {
        //     'Accept': 'application/json',
        //     'Content-Type': 'application/json',            
        // }}).then(res => {
        //     console.log("media =>" , res)
        // })
    }, [])


    return (
        
        // <StepsWrapper loaded={loaded} stepGroupTitle={stepGroupTitle} title={t('general.open_pro_account')}>
        <StepsWrapper loaded={loaded} stepGroupTitle={stepGroupTitle}>
            {id === "usage" && <PrivateUsage {...step_init} />}
            {id === "occupation" && <OccupationActivity {...step_init} />}
            {id === "income" && <Income {...step_init} />}
            {id === "income-source" && <IncomeSource {...step_init} />}
            {id === "income-source-other" && <IncomeSourceOther {...step_init} />}
            {id === "fiscal-residence" && <FiscalResidence {...step_init} />}
            {id === "us-address" && <HasUsAddress {...step_init} />}
            {id === "us-citizen" && <UsCitizen {...step_init} />}
            {id === "political" && <Political {...step_init} />}
            {id === "insider" && <Insider {...step_init} />}
            {id === "join-reason" && <JoinReason {...step_init} />}
            {id === "join-reason-other" && <JoinReasonOther {...step_init} />}

            {id === "id-card" && <IDStep {...step_init} />}

        </StepsWrapper>
    )
}


export default LegalSteps



